
import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const ExperiencedFAQ = () => {
  const faqs = [
    {
      question: "Hvor avanceret skal jeg være for at deltage i undervisning for øvede?",
      answer: "Undervisning for øvede pianister er velegnet for dem, der har minimum 3-5 års erfaring med klaverspil, og som behersker grundlæggende teknikker og kan spille stykker på et mellemniveau til avanceret niveau. Hvis du er i tvivl om dit niveau, er du velkommen til at kontakte mig for en vurdering."
    },
    {
      question: "Kan du hjælpe med forberedelse til konservatoriet eller musikkonkurrencer?",
      answer: "Absolut. Jeg har erfaring med at forberede elever til både optagelsesprøver på konservatorier og forskellige musikkonkurrencer. Vi vil arbejde målrettet med repertoiret, teknik og fremførelsesaspekter, samt mentale forberedelsesstrategier."
    },
    {
      question: "Underviser du i specifikke musikgenrer eller stilarter?",
      answer: "Jeg underviser i en bred vifte af musikgenrer og stilarter, herunder klassisk, romantisk, moderne, jazz, filmmusik og populærmusik. Min specialitet er klassisk og romantisk repertoire, men jeg tilpasser undervisningen efter dine interesser og mål."
    },
    {
      question: "Hvor ofte anbefaler du undervisning for øvede pianister?",
      answer: "For øvede pianister anbefaler jeg typisk ugentlige lektioner på 45-60 minutter for at sikre kontinuerlig progression. Afhængigt af dine mål og din tidsplan kan vi også arrangere længere lektioner eller intensivperioder forud for koncerter eller prøver."
    },
    {
      question: "Kan jeg få hjælp med specifikke tekniske problemer i mit spil?",
      answer: "Ja, en af mine styrker som underviser er at identificere og løse specifikke tekniske barrierer i dit spil. Hvad enten det drejer sig om hurtighed, præcision, fingerstyrke, ekspressivitet eller andre aspekter, vil jeg give dig målrettede øvelser og strategier."
    }
  ];

  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl font-serif font-bold mb-8 text-center">
            Ofte stillede spørgsmål om undervisning for øvede
          </h2>
          
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-left font-medium">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default ExperiencedFAQ;
